<template>
	<div>
		<p class="help-desc">
			하이모 이용기간과 누적 구매금액에 따라 회원 등급이 적용되며, 등급에 따라
			다양한 혜택을 드립니다.
		</p>
		<section class="membership-section">
			<h2 class="membership-title">
				회원등급 기준 <span class="px-2 body-2">*2022년 3월부터 적용</span>
			</h2>

			<table class="membership-table">
				<colgroup>
					<col style="width: 24%" />
					<col />
					<col />
				</colgroup>
				<thead>
					<tr>
						<th scope="col" rowspan="2">회원 구분</th>
						<th scope="colgroup" colspan="2">회원 등급 기준 (A 또는 B 조건 중 하나 이상 충족 시)</th>
					</tr>
					<tr>
						<th scope="col">A. 이용기간 내<br />구매 제품수</th>
						<th scope="col">B. 누적 구매 금액</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--silver">
								<span
									:style="'background-image: url(' + icoGradeSilver + ');'"
									class="mb-grade__icon"
								></span>
								실버
							</div>
						</th>
						<td>
							<strong>2년</strong> 미만<br />
							+<br />
							<strong>제품 2개</strong> 이하
						</td>
						<td>
							<strong>200만원</strong><br />
							미만
						</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--gold">
								<span
									:style="'background-image: url(' + icoGradeGold + ');'"
									class="mb-grade__icon"
								></span>
								골드
							</div>
						</th>
						<td>
							<strong>2년</strong> 이상<br />
							+<br />
							<strong>제품 3개</strong> 이상
						</td>
						<td>
							<strong>200만원</strong><br />
							이상
						</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--platinum">
								<span
									:style="'background-image: url(' + icoGradePlatinum + ');'"
									class="mb-grade__icon"
								></span>
								플래티넘
							</div>
						</th>
						<td>
							<strong>5년</strong> 이상<br />
							+<br />
							<strong>제품 5개</strong> 이상
						</td>
						<td>
							<strong>1,000만원</strong><br />
							이상
						</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--diamond">
								<span
									:style="'background-image: url(' + icoGradeDiamond + ');'"
									class="mb-grade__icon"
								></span>
								다이아몬드
							</div>
						</th>
						<td>
							<strong>10년</strong> 이상<br />
							+<br />
							<strong>제품 10개</strong> 이상
						</td>
						<td>
							<strong>2,000만원</strong><br />
							이상
						</td>
					</tr>
				</tbody>
			</table>

			<ol class="order-list">
				<li class="order-list__item">
					[이용기간 내 구매 제품수] 또는 [누적 구매금액] 기준 등급 중 높은
					등급으로 부여됩니다.
				</li>
				<li class="order-list__item">
					[이용기간 내 구매 제품수]등급은 [이용기간]과 [구매제품수] 기준을 모두
					충족한 경우 해당 등급 부여됩니다.
				</li>
				<li class="order-list__item">
					[누적 구매금액]은 가발, 서비스, 소모품 등 총 결제금액 기준 입니다.
				</li>
				<li class="order-list__item">
					최근 2년 이내 제품 계약 없을 시 위 조건에 의해 부여된 등급에서 1등급
					하향됩니다.
				</li>
				<li class="order-list__item">
					최근 3년 이상 제품 및 서비스 미이용 시, 실버 등급이 부여됩니다.
				</li>
				<li class="order-list__item">
					회원 등급은 매년 12월 31일을 기준으로 새롭게 산정되며 그 기준은 회사
					정책에 따라 변경될 수 있습니다.
				</li>
			</ol>
		</section>

		<section class="membership-section">
			<h2 class="membership-title">회원 등급별 혜택</h2>
			<p class="help-desc">
				회원 등급에 따라 마일리지 적립과 할인쿠폰, 소모품 교환권이 증정 됩니다.
			</p>

			<table class="membership-table">
				<colgroup>
					<col style="width: 24%" />
					<col />
					<col />
					<col />
					<col />
				</colgroup>
				<thead>
					<tr>
						<th scope="col" rowspan="2">회원 구분</th>
						<th scope="col" rowspan="2">마일리지<br />적립율</th>
						<th scope="colgroup" colspan="3">등급별 혜택</th>
					</tr>
					<tr>
						<th scope="col">제품<br />할인</th>
						<th scope="col">수선<br />할인</th>
						<th scope="col">소모품<br />교환권</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--silver">
								<span
									:style="'background-image: url(' + icoGradeSilver + ');'"
									class="mb-grade__icon"
								></span>
								실버
							</div>
						</th>
						<td><strong>3.0</strong>%</td>
						<td>10만원<br />x 1회</td>
						<td>-</td>
						<td>-</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--gold">
								<span
									:style="'background-image: url(' + icoGradeGold + ');'"
									class="mb-grade__icon"
								></span>
								골드
							</div>
						</th>
						<td><strong>3.5</strong>%</td>
						<td>10만원<br />x 1회</td>
						<td>-</td>
						<td>3만원</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--platinum">
								<span
									:style="'background-image: url(' + icoGradePlatinum + ');'"
									class="mb-grade__icon"
								></span>
								플래티넘
							</div>
						</th>
						<td><strong>4.0</strong>%</td>
						<td>10만원<br />x 2회</td>
						<td>5만원<br />x 1회</td>
						<td>4만원</td>
					</tr>
					<tr>
						<th scope="row">
							<div class="mb-grade mb-grade--diamond">
								<span
									:style="'background-image: url(' + icoGradeDiamond + ');'"
									class="mb-grade__icon"
								></span>
								다이아몬드
							</div>
						</th>
						<td><strong>4.5</strong>%</td>
						<td>10만원<br />x 2회</td>
						<td>5만원<br />x 2회</td>
						<td>5만원</td>
					</tr>
				</tbody>
			</table>
		</section>

		<section class="membership-section">
			<h2 class="membership-title">할인 쿠폰 및 소모품 교환권 이용 안내</h2>

			<div class="sale-coupon-grid">
				<div
					class="sale-coupon"
					:style="'background-image: url(' + coupon + ')'"
				></div>

				<ul class="sale-coupon-info">
					<li class="sale-coupon-info__item">
						소모품 교환권은 할인행사 적용 제품에는 사용이 불가합니다.
					</li>
					<li class="sale-coupon-info__item">
						할인 쿠폰 및 소모품 교환권은 매년 12월 31일까지 유효합니다.
					</li>
					<li class="sale-coupon-info__item">
						할인 쿠폰 및 소모품 교환권은 광고문자 수신 동의 고객에 한하여
						사용가능합니다.
					</li>
					<li class="sale-coupon-info__item">
						제품 할인 쿠폰은 계약 건 당 1장 적용되며 중복 사용 불가합니다.
					</li>
					<li class="sale-coupon-info__item">
						신규 고객의 경우 첫 구매 제품 피팅일 이후에 할인쿠폰이 증정됩니다.
					</li>
					<li class="sale-coupon-info__item">
						소모품 교환권은 1회성으로 교환권 금액보다 저가 상품 구매 시 잔액은
						재사용이 불가합니다.
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import icoGradeSilver from '@/assets/images/membership/ico-grade-silver.svg';
import icoGradeGold from '@/assets/images/membership/ico-grade-gold.svg';
import icoGradePlatinum from '@/assets/images/membership/ico-grade-platinum.svg';
import icoGradeDiamond from '@/assets/images/membership/ico-grade-diamond.svg';

import coupon from '@/assets/images/membership/coupon.png';

export default {
	data() {
		return {
			coupon,
		};
	},
	computed: {
		icoGradeSilver() {
			return icoGradeSilver;
		},
		icoGradeGold() {
			return icoGradeGold;
		},
		icoGradePlatinum() {
			return icoGradePlatinum;
		},
		icoGradeDiamond() {
			return icoGradeDiamond;
		},
	},
};
</script>

<style scoped>
.membership-section {
	padding: 1.5rem 0;
}

.membership-section:first-child {
	padding-top: 0;
}

.membership-title {
	margin-bottom: 0.5rem;
	font-size: 1rem;
	font-weight: 500;
}

.membership-table {
	width: 100%;
	margin: 1rem 0;
}

.membership-table thead {
	border-bottom: 1px solid #424242;
}

.membership-table thead th {
	border-bottom: 1px dashed #c6c6c6;
	height: 2.0625rem;
	font-size: 0.8125rem;
}

.membership-table th,
.membership-table td {
	vertical-align: middle;
	padding: 0.25rem;
	height: 3.75rem;
	border-right: 1px dashed #c6c6c6;
	border-bottom: 1px solid #c6c6c6;
	font-size: 0.75rem;
	font-weight: 400;
	text-align: center;
}

.membership-table tbody th,
.membership-table tbody td {
	padding: 1rem 0.25rem;
	color: var(--secondary-color);
}

.membership-table tbody th strong,
.membership-table tbody td strong {
	font-weight: 700;
}

.membership-table tr th:last-child,
.membership-table tr td:last-child {
	border-right: 0;
}

.membership-table tr:last-child th,
.membership-table tr:last-child td {
	border-bottom: 0;
}

.mb-grade {
	font-size: 0.875rem;
	font-weight: 500;
}

.mb-grade--silver {
	color: #aaa9a9;
}

.mb-grade--gold {
	color: #cfad61;
}

.mb-grade--platinum {
	color: #998cc2;
}

.mb-grade--diamond {
	color: #4fbfc9;
}

.mb-grade__icon {
	display: block;
	width: 2.25rem;
	height: 1.875rem;
	background-repeat: no-repeat;
	background-position: 0 0;
	-webkit-background-size: contain;
	background-size: contain;
	margin: 0 auto;
}

.mb-grade-detail {
	padding: 0 0.625rem;
	color: #666;
	font-size: 0.75rem;
	font-weight: 300;
	line-height: 1.25;
}

.help-desc {
	color: #666;
	font-size: 0.8125rem;
	font-weight: 300;
}

.sale-coupon-grid {
	margin: 1rem 0;
}

.sale-coupon {
	float: left;
	width: 120px;
	height: 140px;
	background-repeat: no-repeat;
	background-position: left center;
	background-size: 100px 77px;
}

.sale-coupon-info__item {
	float: left;
	margin: 0.5rem 0;
	padding-left: 0.4375rem;
	color: #222;
	font-size: 0.8125rem;
	line-height: 1.5;
}
.sale-coupon-info__item:nth-child(-n + 2) {
	width: calc(100% - 120px);
}

.sale-coupon-info__item:nth-child(n + 3) {
	clear: both;
}

.sale-coupon-info__item::before {
	content: '';
	display: inline-block;
	width: 0.1875rem;
	height: 0.1875rem;
	margin: 0.5rem 0 0 -0.4375rem;
	border-radius: 50%;
	background: #00477b;
}

.sale-coupon-info__item::after {
	content: '';
	display: table;
	clear: both;
}
</style>
